import React, { useState } from "react";
import Navigation from "./Navigation";
import { FaBeer, HiMenu } from "react-icons/hi";
import { BiHomeAlt2 } from "react-icons/bi";

const Sidebar = () => {
  return (
    <div className="sideMenu">
      <div className="enteteNav bg-primaryss d-flex justify-content-center align-items-center">
        <p
          style={{ color: "#1d4c26 !important" }}
          className="logo d-flex justify-content-center align-items-center fw-bold display-6 text-whites"
        >
          <span className="logoMenu">Se</span>
          <span className="logoMenu">same</span>
          {/* <HiMenu className="mt-2 mx-1 fs-2 rounded p-1 btn-toggle" /> */}
          <BiHomeAlt2 className="btn-nav-home" />
        </p>
      </div>
      <div className="d-flex justify-content-center ">
        <div className="px-3 py-1 navigation sidebarResponsive">
          <p className="px-3 logoMenu mb-0 mt-3">Accueil</p>
          <Navigation />
        </div> 
      </div>
    </div>
  );
};

export default Sidebar;
